import { ActorUserProfile, PartnerSicaProfile } from 'app/modules/models/profile-management/actorUserProfile.type';

const PARTNER_SICA_PROFILES_KEY = 'partnerSicaProfiles';

export function getStoredPartnerSicaProfiles(): PartnerSicaProfile[] {
  try {
    const profiles: unknown = JSON.parse(localStorage.getItem(PARTNER_SICA_PROFILES_KEY) ?? '[]');
    return Array.isArray(profiles)
      ? profiles.filter((profile): profile is PartnerSicaProfile =>
        !!profile && typeof profile.id === 'string' && typeof profile.name === 'string')
      : [];
  } catch {
    return [];
  }
}

export function storePartnerSicaProfiles(links: readonly ActorUserProfile[]): PartnerSicaProfile[] {
  const profiles = links
    .filter(link => !!link.userProfile?.id && !!link.userProfile?.name)
    .map(link => ({ id: link.userProfile.id, name: link.userProfile.name }));
  localStorage.setItem(PARTNER_SICA_PROFILES_KEY, JSON.stringify(profiles));
  return profiles;
}

export function clearPartnerSicaProfiles(): void {
  localStorage.removeItem(PARTNER_SICA_PROFILES_KEY);
}

export function hasAvantTravauxAccess(
  profiles: readonly PartnerSicaProfile[] = getStoredPartnerSicaProfiles()
): boolean {
  return profiles.some(profile => profile.name.trim().toLowerCase() === 'avant travaux');
}

export function hasCssIndirectAccess(
  profiles: readonly PartnerSicaProfile[] = getStoredPartnerSicaProfiles()
): boolean {
  return profiles.some(profile => profile.name.trim().toLowerCase() === 'css indirect');
}

function hasEligibleProjectProfile(profiles: readonly PartnerSicaProfile[]): boolean {
  return profiles.some(profile =>
    ['avant travaux', 'css indirect'].includes(profile.name.trim().toLowerCase()));
}

export function hasDocumentVerificationAccess(
  profiles: readonly PartnerSicaProfile[] = getStoredPartnerSicaProfiles()
): boolean {
  return hasEligibleProjectProfile(profiles);
}

export function hasAhCdcGenerationAccess(
  profiles: readonly PartnerSicaProfile[] = getStoredPartnerSicaProfiles()
): boolean {
  return hasEligibleProjectProfile(profiles);
}
